import script from "./PriceComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceComparison.vue?vue&type=script&setup=true&lang=js"

import "./PriceComparison.vue?vue&type=style&index=0&id=c3e0d932&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3e0d932"]])

export default __exports__